import { ContentSection } from '@cinch-labs/design-system'
import type { ArticleBody as ArticleBodyProps } from '@cinch-nx/landing-ui-articles'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import React from 'react'

export const LeadParagraph: React.FC<ArticleBodyProps> = ({ body }) => {
  if (!body || Object.keys(body).length === 0) {
    return null
  }

  return <ContentSection>{renderWithResolver(body)}</ContentSection>
}
